import useWindowEventHandlers from "hooks/useEventDispatcher";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ChitRequest from "pages/ChitRequest/ChitRequest";
import { useDispatch } from "react-redux";
import TimeRecordingHelper from "./MyMatters/TimeRecordingHelper";
import MatterForm from "pages/Matters/MatterForm";
import { getClientData, getMatterAllInfo } from "api";
import {
  clearMattersBalances,
  getMattersAllURLInfo,
} from "actions/matters.action";
import { Dialog } from "@progress/kendo-react-dialogs";
import clientStyles from "../pages/Clients/Clients.module.scss";
import { Button } from "@progress/kendo-react-buttons";
import AddClients from "pages/Clients/AddViewClients";

const EventListenerComponent = () => {
  const { registerHandler } = useWindowEventHandlers();
  const [showMatterForm, setshowMatterForm] = useState(false);
  const [selectedMatter, setSelectedMatter] = useState(null);
  const [clientData, setClientData] = useState({});
  const [showClientForm, setShowClientForm] = useState(false);
  const [timeRecordingModal, setTimeRecordingModal] = useState(false);
  const [chitRequestModal, setChitRequestModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  console.log(selectedMatter);

  const actionDispatcher = async (action, id) => {
    try {
      const response = await getMatterAllInfo(id);
      setSelectedMatter(response.data.data);
      switch (action) {
        case "ViewMatter":
          setshowMatterForm(true);
          dispatch(getMattersAllURLInfo(response, false));
          return;
        case "AddChit":
          setChitRequestModal(true);
          return;
        case "AddTime":
          setTimeRecordingModal(true);
          return;
        default:
          return;
      }
    } catch (error) {
      alert("No matter exists against this Id. Try again with a different Id");
      navigate("/matters");
    }
  };

  const clientsDataGetter = async (id) => {
    try {
      const data = await getClientData(id);
      setClientData(data?.data?.data);
      setShowClientForm(true);
    } catch (error) {
      alert("No client exists against this Id. Try again with different Id");
    }
  };

  const closeAllDialogs = () => {
    setTimeRecordingModal(false);
    setChitRequestModal(false);
    setshowMatterForm(false);
    setShowClientForm(false);
    setSelectedMatter(null);
    setClientData({});
  };

  useEffect(() => {
    registerHandler("OpenClients", () => {
      closeAllDialogs();
      navigate("/clients");
    });

    registerHandler("OpenMatters", () => {
      closeAllDialogs();
      navigate("/matters");
    });

    registerHandler("OpenDashboard", () => {
      closeAllDialogs();
      navigate("/dashboard");
    });

    registerHandler("OpenOnboarding", () => {
      closeAllDialogs();
      navigate("/clients/onboarding");
    });

    registerHandler("OpenCasefile", (matterId) => {
      try {
        window.chrome.webview.postMessage("CasefileOpened:" + matterId);
      } catch (error) {}

      closeAllDialogs();
      navigate(`/matters/${matterId}`);
    });

    registerHandler("ViewMatter", (matterId) => {
      closeAllDialogs();
      actionDispatcher("ViewMatter", matterId);
    });

    registerHandler("AddChit", (matterId) => {
      closeAllDialogs();
      actionDispatcher("AddChit", matterId);
    });

    registerHandler("AddTime", (matterId) => {
      closeAllDialogs();
      actionDispatcher("AddTime", matterId);
    });

    registerHandler("ViewClient", (clientId) => {
      closeAllDialogs();
      clientsDataGetter(clientId);
    });
  }, [registerHandler, navigate]);

  return (
    <>
      {chitRequestModal && (
        <ChitRequest
          cancelEdit={() => {
            setChitRequestModal(false);
            setSelectedMatter();
            dispatch(clearMattersBalances("Chit Request"));
          }}
          matter={selectedMatter}
          component={"modal"}
        />
      )}

      {timeRecordingModal && (
        <TimeRecordingHelper
          cancelEdit={() => {
            setTimeRecordingModal(false);
            setSelectedMatter();
            dispatch(clearMattersBalances("Time Recording"));
          }}
          matter={selectedMatter}
        />
      )}

      {showMatterForm && (
        <MatterForm
          isView={selectedMatter?.matterRef !== undefined}
          reference={selectedMatter?.matterRef}
          onMatterRefClickActions={() => {}}
          setshowMatterForm={() => {
            setshowMatterForm(false);
            setSelectedMatter();
          }}
        />
      )}

      {showClientForm && (
        <Dialog
          title={"Update Client"}
          onClose={() => {
            setShowClientForm(false);
          }}
          open={() => {
            setShowClientForm(true);
          }}
          className="dialog-xxl"
          // width={"80vw"}
        >
          <div className={`container ${clientStyles["clinet-dialog-top-div"]}`}>
            <div className="">
              <AddClients
                data={clientData}
                isView={true}
                formId={"edit"}
                type="VIEW"
                // title={`Add Client`}
                onClose={() => {
                  setShowClientForm(false);
                }}
                open={() => {
                  setShowClientForm(true);
                }}
              />
            </div>
          </div>
          <div className="dialog-footer mt-2 px-0">
            <Button
              type="button"
              className="common-btn bgBtnSecondary border-0 me-2"
              onClick={() => {
                setShowClientForm(false);
              }}
            >
              Cancel
            </Button>
            <Button
              className="common-btn me-4"
              type="submit"
              onClick={() =>
                document.getElementById("client-submitter").click()
              }
              form={"edit"}
            >
              {"Update Client"}
            </Button>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default EventListenerComponent;
